module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"import":"Импорт вакансий","importDescription":"Эти вакансии есть на Rabota.ru, но в Huntica их, вероятно, нет. Выберите вакансии, которые вы хотите импортировать в Huntica для получения видеооткликов"}}')
  delete Component.options._Ctor
}
